import { Pipe, PipeTransform } from '@angular/core';
import { KeyType } from '../../types';

@Pipe({
  name: 'arrayMap',
  standalone: false
})
export class ArrayMapPipe implements PipeTransform {
  transform(value: any[], ...args: string[]): unknown {
    if (!value) {
      return value;
    }
    return value.map((item) => {
      const oldKeys = args[0].split(',');
      const newKeys = args[1].split(',');
      const newItem: KeyType = {};
      newKeys.forEach((key, index) => {
        newItem[key] = item[oldKeys[index]];
      });
      return newItem;
    });
  }
}
